import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import mime from 'mime-types';
import { downloadFileFromS3 } from '@lib/saveSurveyToS3';

const useFileDownloader = () => {
  const dispatch = useDispatch();

  const getFile = useCallback(
    async (patient_guid: string, filename: string) => {
      const contents = (await downloadFileFromS3(patient_guid, filename, dispatch)) as string;
      const base64 = contents.split(',')[1];

      const byteCharacters = atob(base64);
      const byteNumbers = Array.from<number>({ length: byteCharacters.length });
      for (let i = 0; i < byteCharacters.length; i += 1) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);

      return new Blob([byteArray], { type: mime.lookup(filename) || undefined });
    },
    [dispatch]
  );

  const downloadFile = useCallback(
    async (patient_guid: string, file_guid: string) => {
      const blob = await getFile(patient_guid, file_guid);
      const url = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = file_guid;
      link.click();

      setTimeout(() => {
        window.URL.revokeObjectURL(url);
      }, 100);
    },
    [getFile]
  );
  const openFileInNewTab = useCallback(
    async (patient_guid: string, file_guid: string) => {
      const blob = await getFile(patient_guid, file_guid);
      const url = window.URL.createObjectURL(blob);
      window.open(url);
    },
    [getFile]
  );

  return { downloadFile, openFileInNewTab };
};

export default useFileDownloader;
